import { customTV } from '../../utils/tailwind';
import { FILTER_SHADOW_ELEVATION_CLASSES } from '../../utils/tailwind/shadowElevation';
export const superEllipse = customTV({
    slots: {
        base: 'relative z-0 flex items-center justify-center',
        childrenWrapper: 'z-10 flex items-center justify-center',
    },
    variants: {
        size: {
            120: 'size-120',
            96: 'size-96',
            88: 'size-88',
            80: 'size-80',
            72: 'size-72',
            64: 'size-64',
            56: 'size-56',
            48: 'size-48',
            40: 'size-40',
            32: 'size-32',
            24: 'size-24',
            20: 'size-20',
            16: 'size-16',
        },
    },
});
export const superEllipseSvg = customTV({
    slots: {
        base: 'absolute top-0 z-0 size-full overflow-visible',
        innerBorder: 'origin-center scale-[0.97]',
        outerBorder: 'origin-center scale-[1.03]',
        highlightBorder: 'origin-center scale-[1.13]',
    },
    variants: {
        shadowElevation: FILTER_SHADOW_ELEVATION_CLASSES,
    },
});
export const superEllipseBadge = customTV({
    base: 'absolute -right-8 bottom-0',
});
export const superEllipseIcon = customTV({});
export const superEllipseText = customTV({});
